// На некоторых устройствах Telegram внедряет WebApp с задержкой — читаем актуально при каждом обращении.

export function getTg(): TelegramWebApp | null {
  try {
    return window.Telegram?.WebApp ?? null;
  } catch {
    return null;
  }
}

export function isRunningInsideTelegram(): boolean {
  // В обычном браузере файл telegram-web-app.js может загрузиться,
  // но initData будет пустым (нет подписи/контекста запуска).
  try {
    const t = getTg();
    if (!t) return false;
    const initData = String(t.initData || '').trim();
    return initData.length > 0;
  } catch {
    return false;
  }
}

export const APP_BOOT_TS = Date.now();

export function setTelegramRequiredScrollLock(locked: boolean): void {
  try {
    const root = document.documentElement;
    const body = document.body;
    if (!root || !body) return;
    root.classList.toggle('telegram-required-lock', !!locked);
    body.classList.toggle('telegram-required-lock', !!locked);
  } catch {
    /* ignore */
  }
}

export function syncTelegramChromeColors(): void {
  try {
    const t = getTg();
    if (!t) return;
    const bottomColor = '#1c1c1e';
    t.setHeaderColor?.('#121212');
    t.setBackgroundColor?.('#121212');
    t.setBottomBarColor?.(bottomColor);
  } catch {
    /* ignore */
  }
}

export function forceTelegramBottomBarColor(color: string): void {
  try {
    const t = getTg();
    if (!t) return;
    t.setBottomBarColor?.(String(color || '').trim());
  } catch {
    /* ignore */
  }
}

export function preemptTelegramBottomBarForTabbarShow(): void {
  try {
    const tabbar = document.querySelector('.app-tabbar');
    if (!tabbar) return;
    if (!tabbar.classList.contains('app-tabbar-hidden')) return;
    forceTelegramBottomBarColor('#1c1c1e');
  } catch {
    /* ignore */
  }
}

let syncTelegramChromeColorsRaf: number | null = null;

export function scheduleTelegramChromeColors(): void {
  if (syncTelegramChromeColorsRaf != null) return;
  syncTelegramChromeColorsRaf = requestAnimationFrame(() => {
    syncTelegramChromeColorsRaf = null;
    try {
      syncTelegramChromeColors();
    } catch {
      /* ignore */
    }
  });
}

export function syncTelegramChromeAfterTabbarTransition(tabbarEl: Element | null): void {
  if (!tabbarEl) {
    scheduleTelegramChromeColors();
    return;
  }
  const el = tabbarEl;
  let called = false;
  function handler(e: Event): void {
    if (e.target !== el) return;
    if ('propertyName' in e && e.propertyName && e.propertyName !== 'transform') return;
    if (called) return;
    called = true;
    el.removeEventListener('transitionend', handler);
    scheduleTelegramChromeColors();
  }
  el.addEventListener('transitionend', handler);
}
